<template>
  <div class="profile">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container mt--6 minHeight">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card no-body body-classes="px-0 pb-1" footer-classes="pb-2" class="createUnionTypeContainer">
            <div slot="header" class="row align-items-center">
              <div class="col-lg-10 col-8">
                <h3 class="mb-0">Create Union Type</h3>
              </div>
              <b-row v-if="loading" class="col-lg-12 col-12 no-gutters">
                <div class="col-lg-12 text-center">
                  <pulse-loader :color="'#3867d6'"></pulse-loader>
                </div>
              </b-row>
            </div>

            <b-row id="unionFormContainer">
              <div class="col-lg-12 col-md-12 col-12">
                <b-card no-body>
                  <b-card-body class="pt-0">
                    <b-row>
                      <form class="w-100">
                        <div class="p-lg-4 px-lg-4 px-md-4 px-sm-4">
                          <div class="row px-4">
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="title">Title </label>
                                <input
                                  v-model.trim="title"
                                  v-validate="'required'"
                                  type="text"
                                  name="title"
                                  data-vv-as="title"
                                  data-vv-name="title"
                                  placeholder="Enter Union Type Title"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('title'),
                                    'has-invalid': errors.has('title'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('title')">
                                  {{ errors.first('title') }}
                                </div>
                              </b-form-group>
                            </div>
                          </div>

                          <div class="row mt-5 px-4">
                            <div class="col-lg-5 col-md-5 col-12">
                              <router-link ref="clear" :to="`/content-provider/union-types/`" exact class="btn btn-outline-vobo pr-5 pl-5 w-sm-100"
                                >Cancel</router-link
                              >
                            </div>
                            <div class="col-lg-7 col-md-7 col-12">
                              <button
                                v-if="action === 'create'"
                                v-promise-btn="{ minTimeout: 1500 }"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="createUnionType">
                                Create Union Type
                              </button>
                              <button
                                v-else-if="action === 'edit'"
                                v-promise-btn="{ minTimeout: 1500 }"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="updateUnionType">
                                Save Changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-row>
                  </b-card-body>
                </b-card>
              </div>
            </b-row>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import * as Cookies from 'js-cookie';
import { Validator } from 'vee-validate';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

Vue.use(Cookies);

export default {
  data() {
    return {
      unionTypeID: null,
      title: '',
      action: '',
      hasError: false,
    };
  },
  computed: {
    loading: {
      get: function () {
        return this.$store.state.contentProvider.uniontypeLoading || false;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedCompany: {
      get: function () {
        let selectedCompany = this.$store.state.company.selectedCompany || null;
        return selectedCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    companyName: {
      get: function () {
        let company = this.$store.state.company.company || null;
        if (company) {
          return company.name;
        }
        return null;
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  mounted() {
    const unionFormContainer = document.getElementById('unionFormContainer');
    unionFormContainer.classList.add('non-clickable');

    let companyID = Cookies.get('companyID') || '';

    if (!companyID || companyID === '') {
      this.$swal
        .fire({
          type: 'warning',
          position: 'center',
          imageWidth: 150,
          title: 'Organization is Required',
          html: 'Please select organization from the dropdown first located in upper left of the screen in order to create union type',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Go back to Content Provider Union Types',
          confirmButtonClass: 'btn btn-primary pr-5 pl-5',
          footer: '<div class="text-center"> </div>',
          buttonsStyling: false,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.value) {
            this.$router.push('/content-provider/union-types/');
          }
        });
      unionFormContainer.classList.add('non-clickable');
    } else {
      this.companyID = companyID;
      unionFormContainer.classList.remove('non-clickable');

      this.action = this.$route.params.action;
      this.unionTypeID = this.$route.params.id;
      if (this.unionTypeID) {
        this.loadUnionTypeItem(this.unionTypeID);
      }
    }
  },
  methods: {
    createUnionType() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          const unionTypeData = {
            title: this.title,
            companyID: this.selectedCompany,
          };
          this.$store
            .dispatch('contentProvider/CREATE_CP_UNIONTYPE', unionTypeData)
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, 'Union Type successfully created');
                (this.unionTypeID = null), (this.title = ''), this.$router.push('/content-provider/union-types');
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, 'Error creating union type');
              }
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
              });
            });
        }
      });
    },
    loadUnionTypeItem(unionTypeID) {
      this.$store.dispatch('contentProvider/GET_CP_UNIONTYPE_BY_ID', unionTypeID).then((res) => {
        this.title = res.title;
      });
    },
    updateUnionType() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          const unionTypeData = { title: this.title };
          const unionTypeID = this.unionTypeID;
          this.loading = true;
          this.$store
            .dispatch('contentProvider/UPDATE_CP_UNIONTYPE', {
              unionTypeData,
              unionTypeID,
            })
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, 'Union Type successfully updated');
                this.loading = false;
                (this.unionTypeID = null), (this.title = ''), this.$router.push('/content-provider/union-types');
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, 'Error updating union type');
              }
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
              });
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.createUnionTypeContainer select {
  color: #525f7f !important;
}
</style>
